import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  activeFilter: {
    color: '#3560FF',
  },
}));
